import { CSSProperties, Dispatch, FC, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import classNames from 'classnames';
import { Action } from 'redux';

import lang from '../../lib/language';
import { RootState } from '../../lib/store';
import { setWelcomeMessageDisplayed as setWelcomeMessageDisplayedCall } from '../../lib/store/app';
import { isFirstLogin } from '../../lib/store/crm/helpers';

import IconNotSubscriber from '../../assets/bigImages/capital_welcome_subscriber.png';
import IconCloseWhite from '../../assets/img/icon-close-white.svg';
import { useIsMobile } from '../../hooks';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';
import { BaseModal, ClickableImage } from '../index';

import styles from './WelcomeSubscriptionPopup.module.scss';

type OwnProps = {};

type Props = OwnProps & ReduxProps;

const WelcomeSubscriptionPopup: FC<Props> = (props: Props): JSX.Element => {
  const {
    individual,
    isWelcomeMessageDisplayed,
    setWelcomeMessageDisplayed,
  } = props;
  const { isMobile } = useIsMobile();
  const isCapitalAndFirstLogin = isFirstLogin(individual);
  const [isDisplayNotSubscriberModal, setIsDisplayNotSubscriberModal] = useState(false);

  useEffect(() => {
    if (!isWelcomeMessageDisplayed) {
      setIsDisplayNotSubscriberModal(isCapitalAndFirstLogin);
    }
  }, [isWelcomeMessageDisplayed]);// eslint-disable-line react-hooks/exhaustive-deps

  if (!isCapitalAndFirstLogin) {
    return <></>;
  }

  const closeWelcomeModal = (): void => {
    setIsDisplayNotSubscriberModal(false);
    setWelcomeMessageDisplayed(true);
  };

  const modalStyle: CSSProperties = isMobile ? {
    paddingBottom: 0,
    margin: 0,
    width: window.innerWidth,
    position: 'fixed',
    alignSelf: 'flex-end',
  } : {};

  const modalContent: JSX.Element = (
    <div className={styles.content}>
      {isMobile && (
      <ClickableImage
        alt=""
        src={IconCloseWhite}
        className={styles.closeIcon}
        onClick={() => (closeWelcomeModal())}
      />
      )}
      <img
        src={IconNotSubscriber}
        className={classNames(styles.image)}
        alt=""
      />
      <h6 className={styles.title}>{lang.commonEnrollmentWelcomeMessage()}</h6>
      <span
        className={styles.descriptipon}
      >
        {lang.commonEnrollmentWelcomeMessageContent()}
      </span>
    </div>
  );

  // display welcome(not subscriber) modal
  return (
    <BaseModal
      customStyle={modalStyle}
      className={styles.modal}
      isOpen={isDisplayNotSubscriberModal}
      unmountOnClose
    >
      {modalContent}
      <Button
        className={styles.button}
        variant={ButtonTypesEnum.Primary}
        onClick={closeWelcomeModal}
      >
        {lang.commonContinueButton2()}
      </Button>
    </BaseModal>
  );
};

const mapStateToProps = (state: RootState) => ({
  individual: state.crm.individualExtendedInfo,
  isWelcomeMessageDisplayed: state.app.isWelcomeMessageDisplayed,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  setWelcomeMessageDisplayed: (status: boolean) => dispatch(setWelcomeMessageDisplayedCall(status)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(WelcomeSubscriptionPopup);
